var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyBox",style:({height : _vm.height ? _vm.height : ''})},[_c('el-image',{attrs:{"src":require('../assets/images/emptyImage.png'),"fit":"cover"}}),_c('div',{staticClass:"empty_text"},[_vm._v(_vm._s(_vm.content))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }